import { DocumentPreview } from "./DocumentPreview";
import { FileTypeIcon } from "./FileTypeIcon";
import { formatBytes } from "@/lib/formatters";
import type { Document } from "@/types";

interface DocumentCardProps {
  document: Document;
  selected?: boolean;
  onClick?: () => void;
  onSelect?: () => void;
}

export function DocumentCard({ document, selected, onClick, onSelect }: DocumentCardProps) {
  return (
    <div
      className={`group relative rounded-xl border bg-surface-0 p-3 transition-all duration-fast dark:bg-dark-surface-1 ${
        selected
          ? "border-accent ring-1 ring-accent/30 shadow-md"
          : "border-border-default shadow-sm hover:shadow-md hover:border-border-strong dark:border-dark-border-default dark:hover:border-dark-border-strong"
      }`}
      onClick={onClick}
    >
      <div className="aspect-[4/3] overflow-hidden rounded-lg bg-surface-2 dark:bg-dark-surface-2">
        <DocumentPreview document={document} className="h-full w-full" />
      </div>

      <div className="mt-2.5 flex items-start gap-2.5">
        <FileTypeIcon extension={document.extension} />
        <div className="min-w-0 flex-1">
          <p className="truncate text-sm font-medium text-text-primary dark:text-dark-text-primary">
            {document.canonicalName}
          </p>
          <p className="text-xs text-text-muted mt-0.5">{formatBytes(document.sizeBytes)}</p>
        </div>
      </div>

      {onSelect && (
        <input
          type="checkbox"
          checked={selected}
          onChange={(e) => {
            e.stopPropagation();
            onSelect();
          }}
          className="absolute right-2.5 top-2.5 h-4 w-4 rounded border-border-strong text-accent focus:ring-accent focus:ring-offset-0 dark:border-dark-border-strong"
        />
      )}
    </div>
  );
}
